export class Telefono {

  numero: string;
  tipoTelefonoId: number;
  icono: string;
  description: string;

  constructor(numero: string, tipoTelefonoId: number) {
    this.numero = numero;
    this.tipoTelefonoId = tipoTelefonoId;
    this.icono = 'phone';
  }

}



// WEBPACK FOOTER //
// ./src/app/security/user/telefono.model.ts